import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useContentList, useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

const FaqSection = () => {
  const { data: header } = useContentObject("home.faq_header", contentFallback("home.faq_header"));
  const { items: faq } = useContentList("home.faq", contentFallback("home.faq"));

  if (faq.length === 0) return null;

  return (
    <section className="relative py-28 bg-[#0a0a0d]">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="ornament"><span>{header?.eyebrow || "FAQ"}</span></div>
          <h2 className="section-title mt-6">{header?.title || "Preguntas Frecuentes"}</h2>
          <div className="gold-divider w-40 mt-6" />
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faq.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="glass rounded-sm border-0 overflow-hidden">
              <AccordionTrigger className="px-6 py-5 hover:no-underline group">
                <div className="flex items-center gap-4 text-left">
                  <span className="font-mono text-xs text-[#d4a843] tabular-nums">0{i + 1}</span>
                  <span className="font-display font-semibold text-[#f0ebe0] group-hover:text-[#f5c542] transition-colors">
                    {item.q}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 pl-16 text-[#b8b3a8] leading-relaxed text-sm">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
